import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'
import { removeCaseError } from '../store/manage/agenda'
import { getCaseError } from '../store/manage/agenda/selector'

interface ILifeCycleProps {
  getState?: (() => RootState) | (() => unknown)
  dispatch?: ThunkDispatch<any, any, AnyAction>
}

export const removeCaseErrorIfExists = (
  caseId: string,
  { getState, dispatch }: ILifeCycleProps
) => {
  const state = getState?.()
  const error = getCaseError(caseId)(state as RootState)

  if (!error) return

  dispatch?.(removeCaseError(caseId))
}
